/**
 * paicIntegration.mock.js
 *
 * Org Design's mock roles (Ops/Finance dataset, Pages/OrgDesign/mockData/
 * orgDesign.mock.js) and Talent Mobility's mock roles (Engineering/Data &
 * Analytics dataset, ./talentMobility.mock.js) don't share an id space today
 * — both are independent mocks with no live backend behind either yet. This
 * alias map is an illustrative cross-reference proving the PAIC Org Redesign
 * screen's reuse of Redeployment/Workforce's people-execution components
 * end-to-end; replace with a real shared role id once both modules read from
 * the same org source.
 */
export const ORG_DESIGN_TM_ROLE_ALIASES = {
  R4: "r-business-analyst", // Operations Analyst (REDUCED) ~ Business Analyst
  R9: "r-sr-analyst", // Financial Analyst (REDUCED) ~ Sr. Data Analyst
  R8: "r-analytics-mgr", // Finance Manager (AUGMENTED) ~ Analytics Manager
};

// New-skill drift for AUGMENTED roles, additive to the linked TM role's own
// ROLE_SKILLS entry. `redundantSkillIds` are skills the augmented role no
// longer needs (now agent-covered) — rendered as red "no longer required"
// tags rather than folded into the match score.
export const AUGMENTED_SKILL_DELTA = {
  R8: {
    addedSkills: [{ skillId: "sk-python", required: 3 }],
    redundantSkillIds: ["sk-people"],
  },
};
